import JWT from '../../helper/jwt.helper'
import { getAnalyticsCharts } from '../../services/tenant/analytics-chart.service'
import { generateItemsMenu } from '../../utils/menu'
import { updateSession } from './session.actions'
import { getProfile } from '../../services/auth/auth.service'

export const MENU_TOGGLE_MENU = 'MENU_TOGGLE_MENU'
export const MENU_TOGGLE_MENU_OPEN = 'MENU_TOGGLE_MENU_OPEN'
export const MENU_CHANGE_MENU = 'MENU_CHANGE_MENU'
export const MENU_UPDATE_ITEMS_MENU = 'MENU_UPDATE_ITEMS_MENU'
export const MENU_UPDATE_ITEM_MENU = 'MENU_UPDATE_ITEM_MENU'
export const MENU_UPDATE_ITEM_SELECTED = 'MENU_UPDATE_ITEM_SELECTED'
export const MENU_RESET_REDUX = 'MENU_RESET_REDUX'
export const MENU_UPDATE_ANALYTICS = 'MENU_UPDATE_ANALYTICS'

export const menuReset = () => ({
  type: MENU_RESET_REDUX
})
export const toggleMenu = () => ({
  type: MENU_TOGGLE_MENU
})
export const toggleMenuOpen = (open = false) => ({
  type: MENU_TOGGLE_MENU_OPEN,
  open
})
export const changeMenu = () => ({
  type: MENU_CHANGE_MENU
})
export const updateItemsMenu = (items = []) => ({
  type: MENU_UPDATE_ITEMS_MENU,
  payload: { items }
})
export const updateItemMenu = (item = { item: '', subItem: '', data: {} }) => ({
  type: MENU_UPDATE_ITEM_MENU,
  payload: { item }
})
export const updateItemSelected = (selected = { item: '', subItem: '' }) => ({
  type: MENU_UPDATE_ITEM_SELECTED,
  payload: { selected }
})

export const permissionsMenu = (data, id, licenses, featureFlag) => {
  return async (dispatch) => {
    dispatch(toggleMenuOpen())
    const profile = await getProfile()
    const { permissions: accessTokenPermission, ...user } = data
    const permissions = JWT.decode(accessTokenPermission)
    dispatch(
      updateSession({
        ...data,
        permissions: permissions.data,
        profile: profile.data,
        notifications: data?.notifications || {}
      })
    )
    return dispatch(updatePermissionMenu(permissions.data, user, id, licenses, featureFlag))
  }
}

export const updatePermissionMenu = (permissions, user, id, licenses = [], featureFlag = {}) => {
  return async (dispatch) => {
    dispatch(toggleMenuOpen(true))
    dispatch(updateItemSelected({ item: '', subItem: '' }))

    const items = generateItemsMenu(permissions, user, id, licenses, featureFlag)
    dispatch(updateItemsMenu(items))

    const response = await getAnalyticsCharts()
    dispatch(toggleMenuOpen(false))
    dispatch(updateMenuAnalytics(items, response.data || []))
    dispatch(toggleMenuOpen(true))
    return response.data || []
  }
}

export const updateMenuAnalytics = (menu, menuAnalyticsList) => ({
  type: MENU_UPDATE_ANALYTICS,
  payload: { menu, menuAnalyticsList }
})

// MF-554 — after reordering the Analytics menu: re-sort its buttons right away (by code), without a
// new login. The permission keys keep the old positions until the next login; only the order changes.
export const MENU_REORDER_ANALYTICS = 'MENU_REORDER_ANALYTICS'
export const reorderMenuAnalytics = (codes = []) => ({
  type: MENU_REORDER_ANALYTICS,
  payload: { codes }
})
